<div class="ipm-inspection-request-deficiency-view">
  @if (!isProjectPage) {
    <div class="ipm-web__header">
      <div class="ipm-web__header-container ipm-web__header-container--width-100">
        <a mat-fab extended class="ipm-web__header-back" routerLink="/deficiency">
          <mat-icon svgIcon="icons-chevron-left"></mat-icon>
          {{ 'header.dashboard' | translate | uppercase }}
        </a>
        <h2 class="ipm-web__header-description">{{ inspectionRequestName }}</h2>
        <!-- TODO: removed till the functionality is enabled<button mat-button class="ipm-inspection-request-deficiency-view__download-report" disabled>
        <mat-icon svgIcon="icon-download-web"></mat-icon>
        <p>
          {{'dashboardBreadcrumb.Report' | translate | uppercase }}
          <br>
            <span>
              {{'dashboardBreadcrumb.GeneratePDF' | translate }}
            </span>
          </p>
        </button> -->
      </div>
      <div class="ipm-web__header-container ipm-inspection-request-deficiency-view__cards-row">
        <app-deficiency-details
          [totalUtAlarmCount]="totalUtAlarmCount"
          [totalRedliningCount]="totalRedliningCount"
          [totalVisualEventsCount]="totalVisualEventsCount"
          [totalEmergencyCounter]="totalEmergencyCounter"
          [totalHighCounter]="totalHighCounter"
          [totalStandardCounter]="totalStandardCounter"
          [totalRoutineCounter]="totalRoutineCounter"
          [totalObservationCounter]="totalObservationCounter"
        ></app-deficiency-details>
      </div>
    </div>
  }
  <div [ngClass]="{ 'ipm-web__content': !isProjectPage }">
    @if (!isProjectPage) {
      <p class="ipm-web__content-title">{{ 'dashboard.Details' | translate }}</p>
    }
    <form class="ipm-web__filter" [formGroup]="filterFormGroup">
      <mat-form-field appearance="fill" class="ipm-web__filter-categories">
        <mat-icon svgIcon="icon-filter" matPrefix></mat-icon>
        <mat-label>{{ 'dashboard.AllDeficiencies' | translate }}</mat-label>
        <mat-select [formControl]="categoriesFormControl" multiple="true">
          <mat-select-trigger>
            {{ selectDeficiencyTriggerText }}
          </mat-select-trigger>
          <mat-option #selectAllOption value="All" (click)="selectAll(selectAllOption.selected)">
            {{ ('dashboard.All' | translate) + ' (' + totalCountOf(deficiencyTypes | enumToArray) + ')' }}
          </mat-option>
          @for (category of deficiencyTypes | enumToArray; track category) {
            <mat-option [value]="category" (click)="checkAllSelected()">
              {{ (category | deficiencyTypeDisplayName) + ' (' + totalCountOf([category]) + ')' }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="ipm-web__filter-search-text">
        <mat-icon svgIcon="icon-search" matPrefix></mat-icon>
        <input matInput [formControl]="searchTextFormControl" />
      </mat-form-field>
    </form>
    <table mat-table [dataSource]="deficiencyDetailsDataSource" matSort class="ipm-web__table">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="deficiencyType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="deficiencyType">
          <p>{{ 'deficiencyView.Deficiency' | translate }} {{ 'deficiencyView.Type' | translate }}</p>
        </th>
        <td mat-cell *matCellDef="let element" [ngClass]="'text'">{{ element.deficiencyType | deficiencyTypeDisplayName }}</td>
      </ng-container>
      <ng-container matColumnDef="equipmentId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="equipmentId">
          <p>{{ 'deficiencyView.Equipment' | translate }} {{ 'deficiencyView.ID' | translate }}</p>
        </th>
        <td mat-cell *matCellDef="let element">
          <a [routerLink]="'jobs/' + element.circuitId + '/tasks/' + element.eventId" [ngClass]="'text'">
            {{ element.equipmentId }}
          </a>
        </td>
      </ng-container>
      <ng-container matColumnDef="cml">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="cml">
          <p>{{ 'deficiencyView.CML' | translate }}</p>
        </th>
        <td mat-cell *matCellDef="let element" [ngClass]="'text'">{{ element.cml }}</td>
      </ng-container>
      <ng-container matColumnDef="finding">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="finding">
          <p>{{ 'deficiencyView.Finding' | translate }}</p>
        </th>
        <td mat-cell *matCellDef="let element" [ngClass]="'text'">{{ element.finding }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="deficiencyDetailsTableColumns; sticky: true" style="color: aliceblue"></tr>
      <tr mat-row *matRowDef="let row; columns: deficiencyDetailsTableColumns"></tr>
    </table>
  </div>
</div>
